const LineChart = () => (
  <>
    <path
      fill="currentColor"
      d="m19.33 8.29-5.584 5.516a.64.64 0 0 1-.442.173.57.57 0 0 1-.423-.173l-2.421-2.421a1.58 1.58 0 0 0-1.156-.479q-.677 0-1.137.479l-4.813 4.844a.5.5 0 0 0-.153.341.47.47 0 0 0 .153.367q.159.16.354.16a.5.5 0 0 0 .354-.16l4.8-4.8a.6.6 0 0 1 .442-.173.6.6 0 0 1 .442.173l2.421 2.421q.46.46 1.137.46t1.136-.46L20 8.998v2.793q0 .213.143.356a.48.48 0 0 0 .357.143.48.48 0 0 0 .357-.143.48.48 0 0 0 .143-.357V8.099a.784.784 0 0 0-.808-.808H16.5a.48.48 0 0 0-.357.144.49.49 0 0 0-.143.356q0 .214.143.357a.48.48 0 0 0 .357.143z"
    />
  </>
)
export default LineChart
